// Social Login Configuration
// TODO: Replace with actual Client IDs and redirect URIs

export const SOCIAL_CONFIG = {
  twitter: {
    // 格式示例: 'M1R3cXZpYm1wX3p...', 通常是长字符串
    clientId: 'MzlPaU5sMDZ3Ylp0eFBPVWt5ejI6MTpjaQ', 
    redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/auth_callback.html` : '',
    authUrl: 'https://twitter.com/i/oauth2/authorize',
    scope: 'users.read tweet.read offline.access',
  },
  discord: {
    // 格式示例: '123456789012345678', 通常是18-19位数字
    clientId: '1454142522631786578', 
    redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/auth_callback.html` : '',
    authUrl: 'https://discord.com/api/oauth2/authorize',
    scope: 'identify',
  },
  github: {
    // 格式示例: 'Ov23li...', 通常以 Ov23 开头 (新版) 或纯 hex 字符串
    clientId: 'Ov23lilFYCb9blQcyS9s', 
    redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/auth_callback.html` : '',
    authUrl: 'https://github.com/login/oauth/authorize',
    scope: 'read:user',
  }
};
